import styled, { css } from 'styled-components';

export const ModalContent = styled.div(
  ({ theme }) => css`
    padding: ${theme.sz.s20};
    gap: ${theme.sz.s4};
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    text-align: center;

    @media (max-width: ${theme.sz.ml}) {
      padding: ${theme.sz.s6};
    }
  `,
);

export const TextWrapper = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.base};
  `,
);

export const HighlightedText = styled.span(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xxs};
  `,
);

export const ModalHeader = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.accent.xl};
  `,
);

export const ButtonsWrapper = styled.div(
  ({ theme }) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s5};
    padding-top: ${theme.sz.s6};
  `,
);

export const FlagImage = styled.img(
  ({ theme }) => css`
    height: ${theme.sz.s20};
    width: ${theme.sz.s20};
  `,
);

export const FlagImageWrapper = styled.div(
  ({ theme }) => css`
    border-radius: ${theme.bo.round};
    border: ${theme.bo.thickWidth} solid ${theme.co.neutral60};
    display: flex;
    align-items: center;
    place-content: center;
    width: ${theme.sz.s20};
    height: ${theme.sz.s20};
  `,
);
